export const FILTER_FIELDS = {
  TAG: "tag",
  WEEKDAY: "weekday",
  TIME_OF_DAY: "timeOfDay",
  EFFICIENCY_SCORE: "queryEfficiencyRange",
};

export const VIEWS_DISABLED_ROUTES = [
  "monitoring/collector_health",
  "admin",
  "admin_console",
  "applications_overview",
];
